const PACKAGE_LOCATION_REQUIRED = 'Please enter a city or airport';
const INVALID_DATES = 'Please select valid dates';
const DISALLOW_INFANT_INTL_FLIGHT = 'Sorry, we do not offer lap infant seating on international flights';
const INFANT_CAPACITY_LIMIT = 'Only one infant per adult is allowed';
const CHILD_AGE_REQUIRED_SIMPLE = "Please enter children's age";
const CHILD_AGE_REQUIRED_BEST_PRICE = "Please enter children's age to get the best price for your group";
export { CHILD_AGE_REQUIRED_BEST_PRICE, CHILD_AGE_REQUIRED_SIMPLE, DISALLOW_INFANT_INTL_FLIGHT, INFANT_CAPACITY_LIMIT, INVALID_DATES, PACKAGE_LOCATION_REQUIRED };
